module.exports = __webpack_public_path__ + "static/media/eye.1303d2a1.png";